import { useQuery } from "@apollo/client";
import { Col, Row } from "antd";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { FRANCE_ADDRESS_ZIP_CODE_CITY } from "utils/api/graphql/queries/referentials";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import Select from "../Components/Select";
import validation from "./validation";

function View({ telecoms, onNext, onBack }) {
  const { t } = useTranslation();

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: { telecoms },
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  const { data: cities, loading } = useQuery(FRANCE_ADDRESS_ZIP_CODE_CITY, {
    variables: {
      where: {
        zipCode: get(values, `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`),
      },
    },
  });
  const citiesArray = get(cities, "franceAddressZipCodeCity.response", []);

  return (
    <Layout>
      <Header
        title="Passons à l’adhésion, nous avons besoin de quelques informations complémentaires"
        highlight="informations complémentaires"
        subtitle="Souscription : Informations complémentaires"
        onBack={onBack}
      />
      <Row justify="center">
        <Col xs={24} md={18}>
          <div className="grid--2 pb-16">
            <Input
              placeholder={"ex : 17, Rue de la victoire"}
              label={"Adresse"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`,
                values,
                ...formProps,
              })}
            />
            <Input
              disabled
              placeholder={"ex : 69001"}
              label={"Code postal"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
                values,
                ...formProps,
              })}
            />
          </div>
          <div className="grid--2">
            <Input
              placeholder={"ex : Rhône"}
              label={"Complément d’adresse"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.COMPLEMENT}.value`,
                values,
                ...formProps,
              })}
            />
            <Select
              disabled
              showSearch
              loading={loading}
              options={citiesArray}
              placeholder={"Sélectionnez ..."}
              label={"Ville"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.CITY}.value`,
                values,
                ...formProps,
              })}
            />
          </div>
        </Col>
      </Row>

      <ActionButtons
        disabled={
          !get(values, `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`) ||
          !isEmpty(formProps.errors)
        }
        onNext={handleSubmit}
        onBack={onBack}
      />
    </Layout>
  );
}

export default View;
